/** GROQ：與 `scripts/migrate-posts-to-sanity.ts` 寫入欄位一致；只讀已發布用 `perspective: 'published'` */
export const postProjection = /* groq */ `{
  _id,
  title,
  "slug": slug.current,
  excerpt,
  category,
  tags,
  contentType,
  publishedAt,
  readingTime,
  rating,
  reviewCount,
  "coverImage": coalesce(coverImageUrl, ""),
  legacyContentJson,
  seo,
  author->{
    "id": _id,
    name,
    "avatar": avatar,
    bio
  }
}`;

export const postsListQuery = /* groq */ `*[_type == "post"] | order(publishedAt desc) ${postProjection}`;

export const postBySlugQuery = /* groq */ `*[_type == "post" && slug.current == $slug][0] ${postProjection}`;
